export const styles = (theme) => ({
    root: {
        padding: '15px 20px 15px 20px'
    }
});
